import { trackEvent } from '../services/analytics';

function SiteHeader() {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <a className="wordmark" href="#top" aria-label="BBABDT home">
          <span aria-hidden="true">🦃</span><span>BBABDT</span>
        </a>
        <nav className="site-nav" aria-label="Main navigation">
          <a href="#details">Details</a>
          <a href="#story">The Story</a>
          <a className="button button--small" href="#rsvp" onClick={() => trackEvent('rsvp_cta_clicked')}>RSVP</a>
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;

